export const back_arrow_left = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#31BAFD;" cx="256" cy="256" r="256"/>
<path style="fill:#2B9ED8;" d="M494.98,347.929L385.812,238.761l-120.96,24.264l-73.688-73.688l-34.878,81.303l13.153,52.336
l173.777,173.777C412.858,471.516,468.421,416.925,494.98,347.929z"/>
<g>
<path style="fill:#324A5E;" d="M385.812,238.761H197.358v-36.202c0-6.606-3.775-12.631-9.719-15.513
   c-5.946-2.882-13.012-2.113-18.199,1.979l-67.722,53.441c-4.143,3.269-6.559,8.256-6.559,13.533s2.417,10.264,6.559,13.533
   l67.722,53.441c3.101,2.448,6.877,3.706,10.681,3.706c2.557,0,5.129-0.569,7.516-1.726c5.944-2.881,9.719-8.907,9.719-15.513
   v-36.202H385.81v-34.476H385.812z"/>
</g>
<path style="fill:#2B3B4E;" d="M95.158,256c0,5.277,2.417,10.264,6.559,13.533l67.722,53.441c3.101,2.448,6.877,3.706,10.681,3.706
c2.557,0,5.129-0.569,7.516-1.726c5.944-2.881,9.719-8.907,9.719-15.513v-36.202H385.81V256H95.158z"/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
`;